import React from "react";

export const DashboardSvg = ({ pathNames }) => {
  const isActive = pathNames === "/home/dashboard-skypoint";
  return (
    <div>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.333 1.5H1.5v5.833h5.833zm9.167 0h-5.833v5.833H16.5zm0 9.167h-5.833V16.5H16.5zm-9.167 0H1.5V16.5h5.833z"
          stroke={isActive ? "#ffffff" : "#667085"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
